import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ForgotPasswordModel } from './forgot-password.model';
import { ResetPasswordModel } from './reset-password.model';
import { ForgotPasswordService } from './forgot-password.service';
import { NavMenuService } from '../nav-menu/nav-menu.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  isStepOne: boolean = true;
  userName: string = '';
  public editForm: UntypedFormGroup = new UntypedFormGroup({
    'userName': new UntypedFormControl('', Validators.required)
  });
  public editForm2: UntypedFormGroup = new UntypedFormGroup({
    'passwordResetCode': new UntypedFormControl(null, Validators.required),
    'proposedPassword': new UntypedFormControl(null, [Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$*.{}?"!@#%&/,><\':;|_~`^\\]\\[\\)\\(]).{1,}')]),
    'confirmPassword': new UntypedFormControl(null)
  }, this.pwdMatchValidator);

  constructor(
    private service: ForgotPasswordService,
    private toastr: ToastrService,
    private router: Router,
    private navMenuService: NavMenuService )
  { }

  ngOnInit() {
    this.isStepOne = true;
    // Reset the nav menus so that the user can only see the non-admin menu options.
    this.navMenuService.getMenuItems();
  }

  pwdMatchValidator(frm: UntypedFormGroup) {
    return frm.get('proposedPassword').value === frm.get('confirmPassword').value
      ? null : { 'mismatch': true };
  }

  onSendRequest() {
    const fpModel = new ForgotPasswordModel();
    fpModel.UserName = this.editForm.get('userName').value;
    this.userName = fpModel.UserName;

    this.service.sendForgotPassword(fpModel).subscribe(data => {
      this.toastr.success('Forgot Password request sent', 'Forgot Password', { closeButton: true });
      this.isStepOne = false;
    }, error => {
      console.log(error);
      this.toastr.error('Error requesting password reset - ' + error.error, 'Forgot Password', { closeButton: true });
    })
  }

  onResetPassword() {
    const resetModel = new ResetPasswordModel();
    resetModel.UserName = this.userName;
    resetModel.Token = this.editForm2.get('passwordResetCode').value;
    resetModel.NewPassword = this.editForm2.get('proposedPassword').value;

    this.service.sendResetPassword(resetModel).subscribe(data => {
      this.toastr.success('Password reset successfully - routing to Login screen', 'Reset Password', { closeButton: true });
      this.isStepOne = false;
      this.router.navigate(['/login']);
    }, error => {
      console.log(error);
      this.toastr.error('Error reseting password - ' + error.error, 'Reset Password', { closeButton: true });
    })
  }
}
